module.exports = __webpack_public_path__ + "static/media/nibss-geofencing-terms.ee1a3c3f.pdf";